import type { TFunction } from "i18next";
import type { ContentI18n } from "@/lib/questContent/types";
import type { AttentionItem } from "./types";

/** useContentLocalizer's per-row function, injected so this module stays pure. */
export type Localize = (
  source: { title: string },
  i18n: ContentI18n | null,
  sourceLang: string | null,
) => { title: string };

/**
 * The row's title in the reader's language. A task row names the task; a task
 * with no source_lang of its own was written in its quest's language.
 */
export function itemTitle(item: AttentionItem, localize: Localize): string {
  return item.taskTitle
    ? localize({ title: item.taskTitle }, item.taskI18n, item.taskSourceLang ?? item.questSourceLang).title
    : localize({ title: item.questTitle }, item.questI18n, item.questSourceLang).title;
}

/** One sentence per item. Counted kinds pluralise. */
export function attentionLine(item: AttentionItem, t: TFunction, localize: Localize): string {
  return t(`attention.kinds.${item.kind}`, { count: item.count, title: itemTitle(item, localize) });
}
